// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".share-icons{padding-top:2px;margin-bottom:-4px}.share-icons a{margin-right:6px}\n", "",{"version":3,"sources":["webpack://./src/components/ShareIcons.scss"],"names":[],"mappings":"AAAA,aACE,eAAgB,CAChB,kBAAmB,CAFrB,eAKI,gBAAiB","sourcesContent":[".share-icons {\n  padding-top: 2px;\n  margin-bottom: -4px;\n\n  a {\n    margin-right: 6px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
